import React from 'react'
import { BlocksPipes } from '../../../../common/types/api/page'
import { WidgetTypes } from '../../../../common/types/api/report'
import wrapperDecorator from '../wrapperDecorator'
import HtmlEditor from './htmlEditor'
import styled from 'styled-components'
import GenericIconButton from '../../../../common/components/actions/genericIconButton'

interface Props extends BlocksPipes {
    openEditor: () => void
    editMode: boolean
    className?: string
    type?: WidgetTypes
}

export function Html({ type, className, template, openEditor, editMode }: Props): JSX.Element {
    const isNotGallery = type !== WidgetTypes.GALLERY
    return (
        <Container className={`${className ?? ''}`} editMode={editMode} showBorder={isNotGallery}>
            {isNotGallery && editMode && (
                <div className="htmlPreviewContainer__actionButtons">
                    <GenericIconButton
                        icon="far fa-edit"
                        onClick={() => {
                            openEditor()
                        }}
                    />
                </div>
            )}
            <div className="htmlPreviewContainer__content">
                <span dangerouslySetInnerHTML={{ __html: template }} />
            </div>
        </Container>
    )
}

const Container = styled.div<{ editMode: boolean; showBorder: boolean }>`
    margin: 30px;
    .htmlPreviewContainer {
        &__actionButtons {
            position: absolute;
            right: 60px;
            transform: translateY(-50%);
            display: flex;
            justify-content: flex-end;
            gap: 4px;
            width: 40px;
        }
        &__content {
            height: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            min-height: 100px;
            padding: 8px;
            border-radius: 4px;
            ${({ theme, editMode, showBorder }) => {
                if (showBorder) return `border: 1px solid ${editMode ? theme['gray-100'] : theme['gray-400']};`
            }}
            ${({ theme, editMode = false, showBorder = true }) => {
                let result = ''
                if (editMode) result += `background: ${theme['gray-100']};`

                if (showBorder) result += `border: 1px solid ${editMode ? theme['gray-100'] : theme['gray-400']};`

                return result
            }}

            span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
`

export default wrapperDecorator({ type: WidgetTypes.PIPES, minHeight: 150, Editor: HtmlEditor })(Html)
